import AccountCardPublicConfigurator from './AccountCardPublicConfigurator';

export default AccountCardPublicConfigurator;
